import { render, staticRenderFns } from "./platformdealer.vue?vue&type=template&id=5aa9411c&scoped=true"
import script from "./platformdealer.vue?vue&type=script&lang=js"
export * from "./platformdealer.vue?vue&type=script&lang=js"
import style0 from "./platformdealer.vue?vue&type=style&index=0&id=5aa9411c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9411c",
  null
  
)

export default component.exports